// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1bbLn","actions":"GroupTable_actions__1Isrf","deleteModalFooter":"GroupTable_deleteModalFooter__13hsh"};